import type { InlineFlow } from "@getuserfeedback/protocol/internal/inline-flow";
import type { InlineFlowRun } from "./inline-flow";

/** @internal Versioned package bridge shared by the SDK root and internal entry. */
export type InlineFlowClientBridge = {
	createInlineFlowRun: (flow: InlineFlow) => InlineFlowRun;
};

// This bridge is package compatibility, not caller authorization. Same-window
// host code already owns the realm in which the SDK and Loader execute.
const INLINE_FLOW_CLIENT_BRIDGE_SYMBOL = Symbol.for(
	"@getuserfeedback/sdk/internal/inline-flow-client-bridge/1",
);

export const attachInlineFlowClientBridge = (
	client: object,
	bridge: InlineFlowClientBridge,
): void => {
	Object.defineProperty(client, INLINE_FLOW_CLIENT_BRIDGE_SYMBOL, {
		configurable: false,
		enumerable: false,
		value: bridge,
		writable: false,
	});
};

export const getInlineFlowClientBridge = (
	client: object,
): InlineFlowClientBridge => {
	const bridge = Reflect.get(client, INLINE_FLOW_CLIENT_BRIDGE_SYMBOL);
	if (
		typeof bridge !== "object" ||
		bridge === null ||
		!("createInlineFlowRun" in bridge) ||
		typeof Reflect.get(bridge, "createInlineFlowRun") !== "function"
	) {
		throw new Error(
			"Inline flows require a compatible client created by @getuserfeedback/sdk.",
		);
	}
	return bridge as InlineFlowClientBridge;
};
